<template>
  <div class="hero-top-mobile g-0 container">
    <div class="hero-top-mobile__bar">
      <div class="hero-top-mobile__brand">
        <a href="/" aria-label="Filmsomniac home">
          <img class="logo" :src="logoSrc" alt="Filmsomniac logo">
        </a>
      </div>
      <div class="hero-top-mobile__actions">
        <button
          class="mobile-nav hero-top-mobile__menu"
          data-testid="mobile-search-open"
          type="button"
          aria-label="Open navigation menu"
          @click="$emit('open-mobile-search')"
        >
          <span class="mobile-menu-icon" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </div>

  <div
    v-if="showBackground"
    :class="backgroundWrapClasses"
    :style="effectiveBackgroundWrapStyle"
    data-testid="hero-background-wrap"
    aria-hidden="true"
  >
    <picture v-if="backgroundSrc" class="hero__bgPicture">
      <source
        v-if="mobileBackgroundSrc"
        media="(max-width: 500px)"
        :srcset="mobileBackgroundSrc"
      >
      <img
        class="hero__bg"
        :src="backgroundSrc"
        alt=""
        @load="$emit('background-load')"
      >
    </picture>
  </div>

  <div :class="contentClasses">
    <div class="row g-0 hero__top">
      <section class="col">
        <div class="top">
          <div class="top-section">
            <div class="logo-section">
              <a href="/" aria-label="Filmsomniac home">
                <img class="logo" :src="logoSrc" alt="Filmsomniac logo">
              </a>
            </div>
            <div class="top-nav">
              <ul class="top-nav__links d-flex gap-8 list-unstyled mb-0">
                <li><a href="/discover">Discover</a></li>
              </ul>
              <ul class="top-nav__auth list-unstyled mb-0">
                <template v-if="!isAuthenticated">
                  <li><a :href="loginPath">Login</a></li>
                  <li class="top-nav__separator" aria-hidden="true">•</li>
                  <li><a href="/sign-up">Register</a></li>
                </template>
                <template v-else>
                  <li><a class="top-nav__username" href="/home">{{ authUsername }}</a></li>
                  <li class="top-nav__separator" aria-hidden="true">•</li>
                  <li><a href="/logout">Logout</a></li>
                </template>
              </ul>
            </div>
          </div>
          <div class="search">
            <TopSearchBar />
            <div class="hamburger">
              <button
                class="mobile-nav"
                type="button"
                aria-label="Open navigation menu"
                @click="$emit('open-mobile-search')"
              >
                <i class="ion-android-menu"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import TopSearchBar from './TopSearchBar.vue'
import { useAuthStore } from '../stores/auth'

const props = defineProps({
  logoSrc: {
    type: String,
    required: true,
  },
  backgroundSrc: {
    type: String,
    default: '',
  },
  mobileBackgroundSrc: {
    type: String,
    default: '',
  },
  backgroundWrapClass: {
    type: [String, Array, Object],
    default: '',
  },
  backgroundWrapStyle: {
    type: [String, Array, Object],
    default: undefined,
  },
  loginPath: {
    type: String,
    required: true,
  },
  showBackground: {
    type: Boolean,
    default: true,
  },
  contentClass: {
    type: [String, Array, Object],
    default: '',
  },
})

defineEmits(['open-mobile-search', 'background-load'])

const auth = useAuthStore()

const isAuthenticated = computed(() => auth.isAuthenticated.value)
const authUsername = computed(() => auth.state.username || 'Account')
const backgroundWrapClasses = computed(() => ['hero__bgWrap', props.backgroundWrapClass])
const effectiveBackgroundWrapStyle = computed(() => (
  props.backgroundSrc ? undefined : props.backgroundWrapStyle
))
const contentClasses = computed(() => ['container g-0 hero__content', props.contentClass])
</script>
